export type StammdatenContact = {
  geburtsdatum: string | null | undefined
  phone: string | null | undefined
  strasse: string | null | undefined
  hausnummer: string | null | undefined
  plz: string | null | undefined
  ort: string | null | undefined
}

const TEXT_FIELDS: (keyof StammdatenContact)[] = [
  'phone',
  'strasse',
  'hausnummer',
  'plz',
  'ort',
]

export function missingStammdaten(t: StammdatenContact): string[] {
  const missing = TEXT_FIELDS.filter((f) => !(t[f] ?? '').trim())
  if (!(t.geburtsdatum ?? '').trim()) {
    missing.unshift('geburtsdatum')
  }
  return missing
}

export function isStammdatenComplete(t: StammdatenContact): boolean {
  return missingStammdaten(t).length === 0
}
